module.exports = __webpack_public_path__ + "static/img/product_society_society_yjgl1.4acc2cd.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_yjgl1.svg
// module id = GDGZ
// module chunks = 0